import React from "react";

import BlogEventLayout from "../components/blogLayoutComp";
import SEO from "../components/seo";


import mainImg from "../images/ai_event_poster.jpeg";

import oneImg from "../images/one.jpeg";
import twoImg from "../images/two.jpeg";
import threeImg from "../images/three.jpeg";
import fourImg from "../images/four.jpeg";
import gartner from "../images/Gartnerhypecycle.png";
import aiImg from "../images/AI_learning.png";


function EventsBlogDetailsPage() {

  return (
    <BlogEventLayout
      title="Building A Career In Artificial Intelligence - Career Foundations Featuring Akshay Chandrasekhar"
      brief="Be a part of the AI revolution. Learn how you can build a career in AI, understand the foundations of AI, and become a successful AI engineer"
      heading1 = "Artificial Intelligence - A Revolution"
      breif1 = "Modern society is an industrial society. Industrial revolutions have paved the way for a better, more connected, and prosperous world. But the current revolution, driven by Artificial Intelligence and Big Data, will potentially have the greatest impact on humankind. Artificial Intelligence is at the forefront of technological advancement today, and it has never been a better time to be a part of the AI juggernaut. <br/><br/> This is what we addressed in ‘Building A Career In Artificial Intelligence’, the first in our Career Foundations series. Featuring <a href='https://www.linkedin.com/in/akshaycs/'> <b>Akshay Chandrasekhar</b> </a> , the Co-Founder and CTO of <a href='https://edisn.ai/'> edisn.ai </a> , ex-Enterprise Engineer at Intel, and an alumnus from the Electronics and Communications branch, 2006."
      heading2 = ""
      imageMain={mainImg}
      blogVideoSrc = {[
        { "link":"https://youtu.be/mkNhjwBHk7g", "title" : "Watch Video"}]
      }
      extraContent =
      {
      <div>
        <div className="container mx-auto flex flex-wrap pt-4 pb-12" id="programs">

            <h3 className="w-full my-2 text-3xl font-bold leading-tight text-center" >Highlights of the event</h3>
            <div className="w-full mb-4">
              <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
            </div>

            <div className="w-1/2 md:w-1/2 mx-auto p-2 flex flex-col  flex-shrink">
              <div className="flex-1 bg-white border-2 rounded-t-lg rounded-b-lg overflow-hidden shadow">
                  
                  <p className="text-gray-800 text-justify text-base px-6 mb-5">
                    The event covered the following topics:
                    <li className="mt-2">
                      What is artificial intelligence, and its impact today
                    </li>
                    <li>
                      The subdomains of artificial intelligence
                    </li>
                    <li>
                      The various paths of a career in artificial intelligence
                    </li>
                    <li>
                      Common job roles in AI and career progressions
                    </li>
                    <li>
                        Upskilling and breaking into the artificial intelligence industry
                    </li>
    
                  </p>
              </div>
            </div>

        </div>

        <section class="bg-white border-b py-8 px-8 text-gray-800">
        <div class="container max-w-5xl mx-auto m-8">
          <h2 class="w-full my-2 text-3xl font-bold leading-tight text-center">Akshay's Insights</h2>
          <div className="w-full mb-6">
            <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
          </div>

          <div className="flex flex-wrap items-center justify-center">
            <div className="w-full  p-6 flex flex-col flex-grow flex-shrink">
              <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
              
                  <div className="w-full font-bold text-2xl text-center text-gray-800 px-6">The Impact of Artificial Intelligence</div>
                  <p className="text-gray-800 text-base  mb-5 mt-4">
                    <li className="pl-4">Artificial intelligence is being adopted across all industries today</li>
                    <li className="pl-4">The availability of large datasets and advancements in CUDA GPUs by NVidia have paved the way for easier AI computing </li>
                    <li className="pl-4">A survey by PwC shows that a large section of CEO/CTOs believe that AI will have an impact larger than the internet itself </li>
                    <li className="pl-4">The Gartner Hype Cycle for emerging technologies in 2020 has AI-based technologies dominating other technologies </li>
                  </p>
                  <img className="h-4/6 w-4/6 border-4 pb-4 mx-auto justify-center items-center" src={gartner} />
              
              </div>
            </div>

            <div className="w-full p-6 mt-4 flex flex-col flex-grow flex-shrink">
              <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
              
                  <div className="w-full font-bold text-2xl text-center text-gray-800 px-6">Classification of Artificial Intelligence, based on Learning Methodology </div>
                  <p className="text-gray-800 text-base  mb-5 mt-4">
                    <li className="pl-4">The way the AI network learns can be classified into reinforced learning, supervised learning, unsupervised learning, and deep learning</li>
                    <li className="pl-4">Supervised learning includes the usage of a labeled dataset to train the network to perform a particular task </li>
                    <li className="pl-4">TUnsupervised learning is mostly based on clustering, to perform the required task in the absence of labeled data </li>
                    <li className="pl-4">Reinforcement learning is teaching a network to perform a set of tasks upon which there is a set reward. </li>
                    <li className="pl-4">Deep learning uses neural networks to achieve the set goal, and each of the above three can work in conjunction with deep learning for better results  </li>
                  </p>
                  
                  <img className="h-4/6 w-4/6 border-4 pb-4 mx-auto justify-center items-center" src={aiImg} />
                  
              </div>
            </div>

            <div className="w-full p-6 mt-4 flex flex-col flex-grow flex-shrink">
              <div className="flex-1 bg-white flex-wrap rounded-t rounded-b-none overflow-hidden shadow">
              
                  <div className="w-full font-bold  text-2xl text-center text-gray-800 px-6">The 3 Fundamental Pillars of AI </div>

                    <p className="mx-12 pt-4">The holy trinity comprises of Applied Mathematics, Domain Expertise, and Tools/Programming Languages
                    </p>
                  <div className=" flex flex-wrap ">
                  <div className="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
                    <div className="flex-1 bg-white border-2 rounded-t rounded-b-none overflow-hidden shadow">
                      
                        <div className="w-full font-bold text-xl text-gray-800 px-6 py-4">Applied Mathematics</div>
                        <p className="text-gray-800 text-justify text-base px-6 mb-5">
                        Applied Mathematics is the base for most of the algorithms used for processing data. DIfferential equations, calculus, probability, etc. are used regularly
                        </p> 
                    </div>
                  </div>

                  <div className="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
                    <div className="flex-1 bg-white border-2 rounded-t rounded-b-none overflow-hidden shadow">
                      
                        <div className="w-full font-bold text-xl text-gray-800 px-6 py-4">Domain Expertise</div>
                        <p className="text-gray-800 text-justify text-base px-6 mb-5">
                        Domain expertise in your industry is essential to adapt AI into your product.
                        </p>
                      
                    </div>
                  </div>

                  <div className="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
                    <div className="flex-1 bg-white border-2 rounded-t rounded-b-none overflow-hidden shadow">
                      
                        <div className="w-full font-bold text-xl text-gray-800 px-6 py-4">Programming Languages</div>
                        <p className="text-gray-800 text-justify text-base px-6 mb-5">
                        Python expertise is critical to a career in AI
                        </p>
                      
                    </div>
                  </div>

                </div>
                
              </div>
            </div>
            </div>
          
        </div>
      </section>

          <section class="bg-white border-b py-8 px-8 text-gray-800">
            <div class="container max-w-5xl mx-auto m-8">
              <h2 class="w-full my-2 text-3xl font-bold leading-tight text-center">Career Paths in AI</h2>
              <div className="w-full mb-6">
                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
              </div>

              <p className="text-justify">
              The different career paths can broadly be classified into <b>AI Research</b>, <b>Applied AI Research</b>, and <b>Applied AI</b>
              <ul className="list-disc pt-4">
              <li className="m-2"> <b>AI Research</b> focuses on producing research papers, theoretical advancements, and research output. This stream is extremely math-heavy, and job positions are mostly limited in number and limited to Ph.D. holders. </li>
              <li className="m-2"> <b>Applied AI</b> is the most predominant career path. Application of research and creating an actual end-user experience using AI is the focus of this career path. Software engineering is a predominant part of this job stream.</li>
              <li className="m-2"> <b>Applied AI Research</b> is a mix of both these streams. Jobs are seen in startups or domain-specific product companies.</li>
              <li className="m-2">The entry-level jobs could be as data analysts, data/AI engineers, or a deep learning engineer</li>
              <li className="m-2">This could progress into a data scientist or a deep learning scientist role.</li>
              <li className="m-2">The importance of software engineering cannot be overstated in the big picture. Senior data scientists would choose the algorithms to use for the solution, while a large number of software engineers are needed to build the actual product by implementing the said algorithms.</li>
              <li className="m-2">A strong base in software engineering, along with knowledge of the AI foundations will pave the way for a successful career in AI</li>
              </ul>

              </p>


            </div>

          </section>
          
          <section class="bg-purple border-b py-8 px-8 ">
            <div class="container max-w-5xl mx-auto m-8">
              <h2 class="w-full my-2 text-3xl font-bold leading-tight text-center">Upskilling and building domain expertise in AI</h2>
              <div className="w-full mb-6">
                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
              </div>
              <div class="flex flex-wrap -mx-4 overflow-hidden">

                <div class="my-4 px-4 w-1/4  overflow-hidden ">
                <img className="h-6 w-6" src={oneImg} />
                Do not focus on paid courses. The best content on AI is available for free in the YouTube channels by MIT, Stanford and IIT Madras, and other online channels 
                </div>

                <div class="my-4 px-4 w-1/4  overflow-hidden ">
                <img className="h-6 w-6" src={twoImg} />
                Focused research, getting information, and building knowledge from the industry leaders will enhance your skillset. 
                </div>

                <div class="my-4 px-4 w-1/4  overflow-hidden ">
                <img className="h-6 w-6" src={threeImg} />
                A post-graduation degree is a formal way of building domain expertise. However, Akshay feels that a degree is not a factor unless domain expertise and knowledge are compromised.
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                <img className="h-6 w-6" src={fourImg} />
                A Non-Computer Science background is never a deterrent to a successful career in AI. There is no entry barrier with regards to the branch, as long as the base foundation of mathematics, programming tools, and domain expertise is set in concrete. 
                </div>

              </div>
            </div>
          </section>

          <section class="bg-white border-b py-8 px-8 text-gray-800">
            <div class="container max-w-5xl mx-auto m-8">
              <h2 class="w-full my-2 text-3xl font-bold leading-tight text-center">Wrap Up</h2>
              <div className="w-full mb-6">
                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
              </div>

              <p className="text-center">The event covered these topics and also covered how Akshay broke into AI, and how his learning path and career path were curated for the same. Akshay also showed us his work at edison.ai, where they’re building a real-time engagement platform based on AI.<br/>

              And that’s a wrap on the first ‘Career Foundations’ event by BMSCE Alumni Club. Who are we, and why are we doing this?<br/><br/>

                We’re just a bunch of people from different walks of life with one common factor - BMSCE. Folks from different industries, geographies, career paths, etc. put under a single umbrella, with the objective of connecting with fellow alumni, expanding our networks, giving back to our community and supporting our cause. <br/><br/>

                Do you think you can contribute to your tribe, bring something new to the table, or just have a good time with your fellow BMSians, join us! 
              </p>

            </div>
          </section>


      </div>
            
      }

    >
    
      <SEO
        title="Events:BMSCE Alumni Club"
        keywords={[`bmsce`, `alumni`, `club`, `getscrewed`]}
      />

    </BlogEventLayout>
  );
}

export default EventsBlogDetailsPage;
